<ng-container *ngIf="{value:productPage$ |async} as productPage">
  <ng-container *ngIf="{value:coilsPage$ |async} as coilsPage">
    <section class="vertical-align-item">
      <div class="text-center">
        <img class="icon-warning" src="assets/images/warning.png">
        <ng-container *ngIf="!coilsPage.value && !productPage.value">
          <h2 class="pb-4">The page requested could not be found.</h2>
          <p>The page you were looking for does not exist.</p>
        </ng-container>

        <ng-container *ngIf="productPage.value">
          <h2>
            {{ 'ssab.notfound.productPage'|cxTranslate }}&nbsp;
            <a class="text-underline" [routerLink]="'/'">{{ 'ssab.notfound.backToHomepage'|cxTranslate }}</a>
          </h2>
        </ng-container>

        <ng-container *ngIf="coilsPage.value">
          <h2>
            {{ 'ssab.notfound.coilsPage'|cxTranslate }}&nbsp;
            <a  class="text-underline" [routerLink]="'/'">{{ 'ssab.notfound.backToHomepage'|cxTranslate }}</a>
          </h2>
        </ng-container>
      </div>
    </section>
  </ng-container>
</ng-container>
